<template>
    <div>
        <template v-if="taxArray">
        <modal name="wagesReceivedModal" classes="v-modal-sec" :min-width="200" :min-height="200" :scrollable="true"
            :reset="true" width="750px" height="auto">
            <div class="v-modal">
                <div class="popup-header fromDetailsPage">
                    <h2 class="popup-title">
                        Wages as per W2
                    </h2>
                    <span @click="closePopup">
                        <em class="material-icons">close</em>
                    </span>
                </div>
                <form @submit.prevent ref="newpetitionformRef" data-vv-scope="wagesReceivedForm">
                    <div class="form-container errorScroll taxreturns_wrap">
                        <template v-for="(taxYear, index) in taxArray">
                            <div class="taxreturns_sec">
                                <label class="small-header">Wages received <strong>{{ taxYear.year }}</strong></label>
                                <div class="vx-row">
                                    <div class="vx-col md:w-2/3">
                                        <div class="uploadsec_wrap">
                                            <div class="w-full">
                                                <div class="form_group" @click="uploadMainDocuments = [];updateLoading(index)">
                                                    <label class="form_label">Documents</label>
                                                    <file-upload
                                                        :fileUploadShowingText="'Browse'"
                                                        v-model="uploadMainDocuments"
                                                        class="file-upload-input mb-0"
                                                        style="height: 50px; padding: 0px"
                                                        :name="'petitionerTaxDocs' + index"
                                                        :multiple="true"
                                                        :hideSelected="true"
                                                        :accept="allDocEntity"
                                                        label="Documents"
                                                        :fieldName="'petitionerTaxDocs'+index"  :cid="'petitionerTaxDocs'+index"
                                                        :emitCategory="index"  @updateData="updateData" >
                                                        <img  class="file-icon" src="@/assets/images/main/file-upload.svg" /> 
                                                    </file-upload>
                                                    <span class="loader" v-if="false && item.filesAreuploading"
                                                        ><img src="@/assets/images/main/loader.gif"
                                                    /></span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <immiInput :onlyNumbers="true" :allowFloatingPoint="true" wrapclass="md:w-1/3" :display="false" :cid="'salary'+index" :formscope="'wagesReceivedForm'" v-model="taxYear.salary" :required="checkProperty(taxYear, 'document', 'length') > 0?true:false" :fieldName="'salary'+index" label="Salary Received($)" placeHolder="Salary Received"/>                               
                                </div>                                
                                <ul class="uploaded-list" v-if="checkProperty(taxYear, 'document', 'length') > 0">
                                    <template v-for="(fil, fileindex) in taxYear['document']">
                                        <vs-chip @click="remove(taxYear['document'], fileindex)" :key="fileindex" closable>
                                            {{ fil.name }}
                                        </vs-chip>
                                    </template>
                                </ul>
                            </div>
                        </template>
                        <div class="text-danger text-sm formerrors"  v-if="taxReturnformerrors!=''">
            <vs-alert
              color="warning"
              class="warning-alert reg-warning-alert no-border-radius"
              icon-pack="IntakePortal"
              icon="IP-information-button"
              active="true"
              >{{ taxReturnformerrors }}</vs-alert
            >
          </div>
                    </div>
                 
                    
                    <div class="popup-footer relative">
                        <vs-button color="dark" class="cancel" type="filled" @click="closePopup">Cancel</vs-button>
                        <vs-button @click="submitTaxReturn" color="success" class="save" type="filled">Submit</vs-button>
                    </div>
                </form>
            </div>
        </modal>
    </template>
    </div>
</template>


  
<script>
import FileUpload from "@/views/FileUpload.vue";
  import immiInput from "@/views/forms/fields/simpleinput.vue";
  import moment from 'moment'
  
  export default {
    props: {
  petition: {
    type: Object,
    default: null
  },
},
    components:{
        immiInput,
        FileUpload
    },
    provide() {
        return {
            parentValidator: this.$validator,
        };
    },
    data() {
      return {
        uploadMainDocuments:[],
        year: 2020,
        currentYear: moment().format('YYYY')-1,
        taxArray:[],
        taxReturnformerrors:''
      };
    },
    methods: {
        closePopup(){
            this.$modal.hide('wagesReceivedModal')
            this.taxReturnformerrors=''
            this.$emit('hidePopup')
        },
        updateData(docs, category){
            let inde = parseInt(category);
            this.taxArray[inde]['filesAreuploading'] = false
            this.taxArray[inde]['document'] = docs;
            this.uploadMainDocuments = [];
        },
        closePopUp() {
            this.$modal.hide('wagesReceivedModal');
        },
        remove(docList, indx) {
            this.removeFileFromS3(docList[indx])
            docList.splice(indx, 1);
            return false;
        },
        updateLoading(index){
            this.taxArray[index]['filesAreuploading'] = true;
        },
        getTaxReturnYearDetails() {
            let payLoad = {};
            let yearPath = '/common/get-wage-tax-year'
            this.$store.dispatch('commonAction', {'data':payLoad,'path':yearPath}).then((response)=>{
                if(response.year){
                    this.year = response.year;
                    let difference = this.currentYear - this.year;
                    for (let index = 0; index <= difference; index++) {
                        let yearToAdd = this.year + index;
                        let obj = {
                            'year': yearToAdd,
                            "salary":'',
                            'document': [],
                            'filesAreuploading':false
                        };
                        let findObj = _.find(this.taxArray, {'year':yearToAdd});
                        if(!findObj){
                            this.taxArray.push(obj);
                        }
                    }
                    if(this.checkProperty(this.taxArray, 'length')>0){
                        this.taxArray.sort((a, b) => b.year - a.year);
                    }
                }
                this.$modal.show('wagesReceivedModal');
            }).catch((err)=>{
                this.$modal.show('wagesReceivedModal');
            })
            
        },
        submitTaxReturn(){
            this.$validator.validateAll('wagesReceivedForm').then(result => {
                if(result){
                    let postData={
                        //'companyId':'6257fc61621cbad27e2774dd'
                    'companyId':this.checkProperty(this.petition,'companyId'),
                    'userId':this.checkProperty(this.petition,'userId'),
                    //'taxReturnYears':[] 6257fc61621cbad27e2774dd
                    }
                    if(this.checkProperty(this.taxArray,'length')>0){
                    postData['wageReceivedYears']=this.taxArray
                    }
                    let path='beneficiary-profile/update-wage-received-years'
                    this.taxReturnformerrors=''
                    this.$store.dispatch('commonAction', {"data":postData ,"path":path}).then((response) => {
                        this.showToster({ message: response.message, isError: false });
                        this.$emit('hidePopup')
                    }).catch((error)=>{
                        this.taxReturnformerrors=error
                    })
                }
            })
        },
        getTaxDetails(){
            let postData={
            'userId':this.checkProperty(this.petition,'userId')
            }
            let path='/beneficiary-profile/get-wage-received-years'
            this.$store.dispatch('commonAction', {"data":postData ,"path":path}).then((response) => {
                if(response && response['wageReceivedYears'] && this.checkProperty(response, 'wageReceivedYears', 'length')>0){
                        this.taxArray = response['wageReceivedYears'];
                    }
                                this.getTaxReturnYearDetails()
            }).catch((error)=>{
                this.getTaxReturnYearDetails()
            })
        }
    },

    mounted() {
        this.getTaxReturnYearDetails();
        this.getTaxDetails()
        
        
    },
  };
</script>

 












